module.exports = __webpack_public_path__ + "img/file2.1c52ebbb.png";